import {ProposalInformation} from './proposal/proposal-information';
import {Partner} from './proposal/partner';
import {ProposalUser} from './proposal/proposalUser';
import {Damage} from './proposal/damage';
import {Proposal} from './proposal/proposal';
import {CompactOffer} from './offer/compact-offer';
import {LineOfBusiness} from './proposal/line-of-business';

export class ProposalSlip {
  issuedAt: Date;
  proposalInformation: ProposalInformation = new ProposalInformation();
  partner: Partner = new Partner();
  user: ProposalUser = new ProposalUser();
  damages: Damage[] = [];
  offers: CompactOffer[] = [];
  lineOfBusiness: LineOfBusiness = null;

  get filteredOffers() {
    return this.offers.filter(offer => offer.isComplete)
      .sort((offer1, offer2) => {
        // Prioritize the offer with isLeading set to true
        if (offer1.isLeading) return -1;
        if (offer2.isLeading) return 1;

        // If neither offer is leading, sort by amountCovered
        return offer2.amountCovered - offer1.amountCovered;
      });
  }

  constructor(proposal?: Partial<Proposal>) {
    if (proposal == null) {
      return;
    }
    this.issuedAt = new Date();

    if (proposal.proposalInformation != null) {
      this.proposalInformation = proposal.proposalInformation;
    }
    if (proposal.partner != null) {
      this.partner = new Partner(proposal.partner);
    }
    if (proposal.creator != null) {
      this.user = new ProposalUser(proposal.creator);
    }
    if (proposal.lineOfBusiness != null) {
      this.lineOfBusiness = new LineOfBusiness(proposal.lineOfBusiness);
    }

    if (proposal.previousDamages != null) {
      proposal.previousDamages.forEach(damage => this.damages.push(new Damage(damage)));
    }
  }

}
